import { h } from "preact";
import { classNames } from "../helpers";

// TODO: Consolidate this with Avatar.jsx
export default function CompanyLogo({ company, link, ...props }) {
  let imageSrc = company.logos?.avatar64;
  if (props.extraBig && company.logos?.avatar256) {
    imageSrc = company.logos?.avatar256;
  }
  const initials = (company.name || "")
    .split(" ")
    .map((n) => n[0])
    .filter((n) => n)
    .slice(0, 2)
    .join("");

  const Tag = props.link ? "a" : "span";

  return (
    <Tag
      href={link}
      class={classNames(
        "avatar",
        props.class,
        props.big && "avatar--big",
        props.extraBig && "avatar--extra-big",
        props.medium && "avatar--medium",
        props.small && "avatar--small",
        props.noHover && "avatar--no-hover"
      )}
    >
      {imageSrc ? (
        <img src={imageSrc} class="avatar__image" />
      ) : initials && !props.extraBig ? (
        initials
      ) : (
        <img src="/images/profile_icon.svg" class="avatar__defaultImage" />
      )}
    </Tag>
  );
}
